<script>
export default {
  name: "SnapshotFeature",
  props: {
    propertyType: "",
    featureText: "",
    feature: ""
  },
  methods: {
    processFeatureType(feature) {
      if (
        feature == 0 ||
        feature == "" ||
        feature == undefined ||
        feature == null
      ) {
        return "TBA";
      } else {
        return feature;
      }
    }
  }
};
</script>

<template>
  <el-row :gutter="20" style="margin-bottom: 16px">
    <el-col :span="7" class="title-txt" v-html="featureText"></el-col>
    <el-col :span="17" class="desc-style omit1">{{
      processFeatureType(this.feature)
    }}</el-col>
  </el-row>
</template>

<style lang="scss" scoped>
.title-txt {
  color: #585858;
  text-align: start;
  font-feature-settings: "clig" off, "liga" off;
  font: 400 12px/125% DINosaur-a, sans-serif;
  line-height: 20px;
}

> .agent-img > img {
  min-width: 50px;
}

.desc-style {
  color: #003333;
  text-align: start;
  font-feature-settings: "clig" off, "liga" off;
  font: 600 12px DINosaur-a, sans-serif;
  line-height: 20px;
  white-space: normal;
}

.omit1 {
  display: -webkit-box;
  overflow: hidden;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
}
</style>



// WEBPACK FOOTER //
// src/components/search/SnapshotFeature.vue